import React, { ReactNode } from "react";
import { forwardRef, Grid } from "@chakra-ui/react";

const InfoItem = forwardRef(({ children }: { children: ReactNode }, ref) => {
  return (
    <Grid
      ref={ref}
      gridTemplateColumns="subgrid"
      gridColumn="1/-1"
    >
      {children}
    </Grid>
  );
});

export default InfoItem;
